import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {ref} from "vue";
import {useI18n} from "vue-i18n";
import KazakhstanCrossBorderPage from "@/components/KazakhstanCrossBorderPage.vue";
import {DealStatus} from "@/enum/DealStatus";
import {InvoiceStatus} from "@/enum/InvoiceStatus";
import {FlowType} from "@/enum/FlowType";
import DealDTO from "@/models/DealDTO";
import InvoiceStateDTO from "@/models/InvoiceStateDTO";


export default /*@__PURE__*/_defineComponent({
  __name: 'KazakhstanCardPreview',
  setup(__props) {

const {t} = useI18n({useScope: 'global'})
const canceledAt = new Date(Date.now() + 12 * 60 * 1000).toISOString()
const transactionId = ref('')
const transactionIdError = ref('')

const deal: DealDTO = {
  id: 'preview-deal',
  status: DealStatus.TRANSFER_WAITING,
  paymentMethod: 'dcbank',
  paymentOption: 'CROSS_BORDER',
  paymentSystem: '',
  requisites: {
    holder: 'BANIMOV SARDOR',
    requisites: '4713380020349417',
  },
  canceledAt,
  createdAt: new Date().toISOString(),
  isActive: true,
  disputeAttachment: null,
  isSumChanged: false,
  matchingEmail: null,
}

const invoice: InvoiceStateDTO = {
  id: 'preview-invoice',
  internalId: '48291',
  status: InvoiceStatus.NEW,
  paymentOption: 'CROSS_BORDER',
  crossBorderCurrency: 'TJS',
  sum: {amount: '15000', currency: 'KZT'},
  expiredAt: canceledAt,
  successUrl: null,
  cancelUrl: null,
  isSumChanged: false,
  isTrxIdRequiredForConfirm: true,
  isUserPhoneRequired: false,
  deals: [deal],
  flow: FlowType.DEFAULT,
  flowData: {
    layout: 'kazakhstan_cross_border',
  },
}

const cancelDeal = () => undefined
const confirmTransfer = () => {
  if (invoice.isTrxIdRequiredForConfirm && transactionId.value.trim() === '') {
    transactionIdError.value = t('invoice.transaction-id-required')
    return
  }
  transactionIdError.value = ''
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(KazakhstanCrossBorderPage, {
    "current-deal": deal,
    invoice: invoice,
    cancelDeal: cancelDeal,
    confirmTransfer: confirmTransfer,
    transactionId: transactionId.value,
    "onUpdate:transactionId": [
      _cache[0] || (_cache[0] = ($event: any) => ((transactionId).value = $event)),
      _cache[1] || (_cache[1] = ($event: any) => (transactionIdError.value = ''))
    ],
    transactionIdError: transactionIdError.value
  }, null, 8, ["transactionId", "transactionIdError"]))
}
}

})